import React from 'react'
import {
    AllEvents,
    BreakingNewsCard,
    createCardClickedEvent,
    useFeature,
} from '@news-mono/web-common'
import {
    MiniWaFootyLivesHereIcon,
    StyledFootyLivesHerePromoStrapContainer,
    StyledFootyLivesHereText,
    StyledInnerContainer,
    StyledInnerTextContainer,
} from './FootyLivesHerePromoStrap.styled'
import { useViewport } from '../../__helpers/use-viewport'

export interface FootyLivesHerePromoStrapProps {
    bannerLink: string
    text: string
    onEvent: (event: AllEvents) => void
    impressionRef: React.RefObject<HTMLDivElement>
}

export const FootyLivesHerePromoStrap = ({
    bannerLink,
    text,
    onEvent,
    impressionRef,
}: FootyLivesHerePromoStrapProps) => {
    const { isMobile } = useViewport()
    const hideOnMobileAndApp = useFeature(
        'hide-mobile-breaking-news-banner',
        true,
    )
    const isFootyLivesHereCampaignWithGuernseyEnabled = useFeature(
        'afl-footy-lives-here-guernsey-earlybird-promo',
        true,
    )

    const item: BreakingNewsCard = {
        shortHeadline: 'FOOTY LIVES HERE',
        link: bannerLink,
        cardType: 'breaking-news',
        listId: 'footy-lives-here-promo-strap',
    }
    const linkClicked = () => {
        onEvent(
            createCardClickedEvent(
                onEvent,
                item,
                'FootyLivesHerePromoStrap',
                'FootyLivesHerePromoStrap',
                1,
            ),
        )
    }

    // I want to split the 'text' on the 'FREE' word and wrap it in a span with different styling
    const highlightedText = text
        .split(/(FREE)/)
        .map((part, index) =>
            part === 'FREE' ? <span key={index}>{part}</span> : part,
        )

    // I want to split the 'save up to 25%' word and wrap it in a span with different styling
    const highlightedTextNew = text
        .split(/(save up to 25%)/i)
        .map((part, index) =>
            part.toLowerCase() === 'save up to 25%' ? (
                <span key={index}>{part}</span>
            ) : (
                part
            ),
        )

    return (
        <div ref={impressionRef}>
            <StyledFootyLivesHerePromoStrapContainer
                hideOnMobileAndApp={hideOnMobileAndApp}
                href={bannerLink}
                onClick={linkClicked}
            >
                <StyledInnerContainer
                    useBackgroundImage={
                        isFootyLivesHereCampaignWithGuernseyEnabled
                    }
                >
                    <MiniWaFootyLivesHereIcon />
                    <StyledInnerTextContainer>
                        <StyledFootyLivesHereText>
                            {isFootyLivesHereCampaignWithGuernseyEnabled
                                ? highlightedText
                                : highlightedTextNew}
                        </StyledFootyLivesHereText>
                    </StyledInnerTextContainer>
                    {!isMobile && <MiniWaFootyLivesHereIcon />}
                </StyledInnerContainer>
            </StyledFootyLivesHerePromoStrapContainer>
        </div>
    )
}
